import { all, fork, put, takeLatest } from 'redux-saga/effects';
import {
    CHANGE_ROUTER,
    LEAVING_ROUTER
} from '../../../iwRouter/IwRouter.actions';

export const registeredPages = [];

export function createWorkersForPage(options) {
    let pageFlowTasks = [];

    const sagaWorkers = [
        fork(pageRouterWorker),
        fork(pageEnableWorker),
        fork(pageLeaveProcessWorker),
        fork(pageDisableWorker)
    ];

    registeredPages.push(options);

    return sagaWorkers;

    function* pageRouterWorker() {
        yield takeLatest(CHANGE_ROUTER, function* (action) {
            if (options.isInPageLocation(action.location)) {
                yield put({ type: `page/${options.page} [enable]` });

                if (!action.disableFirstRouterChange) {
                    yield put({ type: `page/${options.page} [activate]` });
                }
            }
        });
    }

    function* pageEnableWorker() {
        yield takeLatest(`page/${options.page} [enable]`, function* () {
            const workers = options.createPageFlowWorkers();
            pageFlowTasks = yield all(workers);
        });
    }

    function* pageLeaveProcessWorker() {
        yield takeLatest(LEAVING_ROUTER, function* (action) {
            if (isLeavingPage(action)) {
                yield put({ type: `page/${options.page} [leaving]` });
                yield put({ type: `page/${options.page} [disable]` });
            }
        });
    }

    function* pageDisableWorker() {
        yield takeLatest(`page/${options.page} [disable]`, function () {
            for (let saga of pageFlowTasks) {
                saga.cancel();
            }
        });
    }

    function isLeavingPage(action) {
        return (
            options.isInPageLocation(action.from) &&
            !options.isInPageLocation(action.to)
        );
    }
}
